"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const common_utils_1 = require("@as-react/common-utils");
class ReviewsAPI {
    constructor() {
        this.postReview = (review, defaultRequestParameters, servicesEndpoint) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${servicesEndpoint}api/review/add`,
                params: defaultRequestParameters,
                data: review,
                withCredentials: true,
            };
            const result = yield common_utils_1.axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
exports.default = new ReviewsAPI();
